<template>
  <div class="mnp-in-data">
    <div class="data-head-box">
      <slot name="txtBefore"></slot>
      <slot v-if="portationTime_ === 'CONTRACT_END'" name="txtContractEnd"></slot>
      <slot v-if="portationTime_ === 'AS_SOON_AS_POSSIBLE'" name="txtASAP"></slot>
      <slot name="txtBeforeLabel"></slot>
      <DataInput
        :portation-msisdn.sync="portationMsisdn"
        :person.sync="person"
        :selected-keys.sync="selectedKeys"
        :invalid.sync="dataInvalid"
      >
        <template v-for="slot in possibleChildSlotsFor('DataInput')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </DataInput>
    </div>
    <div class="payment-information">
      <slot name="txtBeforePaymentInformation"></slot>
      <ChangePaymentViewWrapper :show-stepper="false">
        <template v-for="slot in possibleChildSlotsFor('ViewWrapper')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </ChangePaymentViewWrapper>
      <slot name="txtAfterPaymentInformation"></slot>
    </div>
    <Stepper
      @prev="back()"
      @next="request()"
      :loading-next="loading"
      :disabled-next="$v.$invalid || loading"
    >
      <template v-for="slot in possibleChildSlotsFor('Stepper')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Stepper>
  </div>
</template>

<script>
import DataInput from '@/components/process/generic/Mnp/MnpIn/DataInput.vue'
import slotProxy from '@/mixins/slotProxy'
import syncProperty from '@/mixins/syncProperty'
import processSteps from '@/mixins/processSteps'
import Stepper from '@/components/generic/Stepper.vue'
import { stepName as previousProcessStep } from './Start.vue'
import { stepName as nextProcessStep } from './Data.vue'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import ChangePaymentViewWrapper from '../../Payment/ChangePayment/ViewWrapper.vue'
import { mapActions, mapMutations } from 'vuex'
import { sameAs } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'

export const stepName = 'mnpInData'
export default {
  name: 'MnpInData',
  data () {
    return {
      loading: false,
      dataInvalid: true,
      portationMsisdn: '',
      selectedKeys: 'default',
      person: {
        gender: '',
        firstName: '',
        lastName: '',
        birthDate: null
      }
    }
  },
  props: {},
  computed: {
    isNoPayment () {
      return this.paymentInformation.paymentType === null
    },
    isCreditCard () {
      if (this.paymentInformation.paymentType !== null) {
        return this.paymentInformation.paymentType.type === 'creditCard'
      }
      return false
    },
    isBankAccount () {
      if (this.paymentInformation.paymentType !== null) {
        return this.paymentInformation.paymentType.type === 'bankAccount'
      }
      return false
    }
  },
  methods: {
    ...mapMutations('mnpIn', [
      'goToStep'
    ]),
    ...mapActions('mnpIn', [
      'performMnpIn'
    ]),
    back () {
      this.goToStep(this.previousStep)
    },
    request () {
      this.loading = true
      this.performMnpIn({
        person: this.person,
        portationMsisdn: this.portationMsisdn,
        selectedKeys: this.selectedKeys,
        nextStep: this.nextStep
      })
        .then(() => {
          this.loading = false
        }, () => {
          this.loading = false
        })
    }
  },
  components: {
    ChangePaymentViewWrapper,
    DataInput,
    Stepper
  },
  mixins: [
    validationMixin,
    slotProxy(),
    processSteps(stepName, previousProcessStep, nextProcessStep),
    syncProperty('portationTime', 'portationTime_')
  ],
  apollo: {
    paymentInformation: function () {
      return wrapQuery(
        gql`query changePayment {
          paymentInformation {
            paymentType {
            ...on BankAccount {
                type
                iban
                owner
              }
              ...on CreditCard {
                type
                holder
                company
                expiryMonth
                expiryYear
                lastDigits
              }
           }
          }
        }`, this, 'paymentInformation'
      )
    }
  },
  validations () {
    return {
      dataInvalid: {
        sameAs: sameAs(() => false)
      }
    }
  }
}
</script>
